export default __webpack_public_path__ + "static/FirstImageGreen-f99a2e4490cfa8550401c0aff10df403.png";